import { render, staticRenderFns } from "./ModalAjuda.vue?vue&type=template&id=d31e8204"
import script from "./ModalAjuda.vue?vue&type=script&lang=js"
export * from "./ModalAjuda.vue?vue&type=script&lang=js"
import style0 from "./ModalAjuda.vue?vue&type=style&index=0&id=d31e8204&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports